import { config } from "./config";

export const msalConfig = {
  auth: {
    clientId: config.AUTH_AZUREAD_CLIENT_ID,
    authority: config.AUTH_AZUREAD_AUTHORITY,
    redirectUri: config.AUTH_AZUREAD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "offline_access"],
};

export const graphConfig = {};
